export default {"src":"/_next/static/media/UNH.847fb88d.svg","height":18,"width":18};